import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { UpsertQRModal } from "modules/campaigns/components/Sections/triggers/qr/UpsertQRModal"
import { SearchSchema } from "./route"

export const Route = createFileRoute("/_base/_auth/settings/channels/qr/create")({
  component: RouteComponent,
})

function RouteComponent() {
  const search = Route.useSearch()
  const navigate = useNavigate()

  function onClose() {
    navigate({ to: "/settings/channels/qr", search: SearchSchema.parse(search) })
  }

  return <UpsertQRModal onClose={onClose} />
}
